export function UmamiScript({websiteId}: {websiteId: string}) {
    return (
        <script async src="https://cloud.umami.is/script.js" data-website-id={websiteId}></script>
    )
}

export default UmamiScript
